<template>
  <div class="pb-7" v-if="!loaded">
    <div class="info-panel" v-if="fieldSettings">
      <div v-if="errorMessage" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-5">
        <div class="d-flex flex-column text-light pe-0 pe-sm-10">
          <span v-html="errorMessage"></span>
        </div>
      </div>
      <div class="border rounded pt-4 pb-4 mb-5">
        <div class="row">
          <div class="col-4">
            <checkbox-field
                v-model="data.filter.person"
                :disabled="true"
                placeholder="Физ. лицо"
                id="filter.person"
                class="form-check-sm justify-content-center"
            />
          </div>
          <div class="col-4">
            <checkbox-field
                v-model="data.filter.resident"
                :disabled="true"
                placeholder="Резидент"
                id="filter.resident"
                class="form-check-sm justify-content-center"
            />
          </div>
          <div class="col-4">
            <checkbox-field
                v-model="data.filter.verify"
                :disabled="true"
                placeholder="Верификация"
                id="filter.verify"
                class="form-check-sm justify-content-center"
            />
          </div>
        </div>
      </div>
      <input-mask-field
          v-model="data.client.iin"
          v-if="fieldSettings.iin.show || (isCreateClient() && fieldSettings.iin.required)"
          id="client.iin"
          name="client_iin"
          :required="fieldSettings.iin.required"
          :disabled="fieldSettings.iin.disabled"
          :mb="5"
          mask="### ### ### ###"
          :placeholder="this.data.filter.person ? 'ИИН' : 'БИН'"
          type="text"
      />
      <input-mask-field
          v-model="data.client.phone"
          v-if="fieldSettings.phone.show || (isCreateClient() && fieldSettings.phone.required)"
          id="client.phone"
          name="client_phone"
          :required="fieldSettings.phone.required"
          :disabled="fieldSettings.iin.disabled"
          :mb="5"
          placeholder="Сотовый номер"
          mask="+7(###) ###-####"
          type="text"
      />
      <template v-if="this.data.filter.person">
        <input-field
            v-model="data.client.name"
            v-if="fieldSettings.name.show || (isCreateClient() && fieldSettings.name.required)"
            id="client.name"
            name="client_name"
            :required="fieldSettings.name.required"
            :disabled="fieldSettings.name.disabled && !isCreateClient()"
            placeholder="Имя"
            type="text"
            mb="5"
        />
      </template>
      <template v-else>
        <area-field
            v-model="data.client.name"
            v-if="fieldSettings.name.show || (isCreateClient() && fieldSettings.name.required)"
            id="client.name"
            name="client_name"
            :required="fieldSettings.name.required"
            :disabled="fieldSettings.name.disabled && !isCreateClient()"
            :class="'h-125px'"
            class="h-auto"
            placeholder="Наименование"
            type="text"
            mb="5"
        />
      </template>
      <input-field
          v-model="data.client.surname"
          v-if="fieldSettings.surname.show || (isCreateClient() && fieldSettings.surname.required)"
          id="client.surname"
          name="client_surname"
          :required="fieldSettings.surname.required"
          :disabled="fieldSettings.surname.disabled && !isCreateClient()"
          placeholder="Фамилия"
          type="text"
          mb="5"
      />
      <input-field
          v-model="data.client.patronymic"
          v-if="fieldSettings.patronymic.show || (isCreateClient() && fieldSettings.patronymic.required)"
          :required="fieldSettings.patronymic.required"
          :disabled="fieldSettings.patronymic.disabled && !isCreateClient()"
          id="client.patronymic"
          name="client_patronymic"
          placeholder="Отчество"
          type="text"
          mb="5"
      />
      <input-field
          v-model="data.client.email"
          v-if="fieldSettings.email.show || (isCreateClient() && fieldSettings.email.required)"
          :required="fieldSettings.email.required"
          :disabled="fieldSettings.email.disabled && !isCreateClient()"
          id="client.email"
          name="client_email"
          :placeholder="'Эл.почта'"
          :has-error="!validEmail"
          type="email"
          :mb="!validEmail ? '2' : '5'"
      />
      <p v-if="!validEmail" class="text-danger ms-3">Некорректный email</p>
      <div class="row">
        <div class="col-6" v-if="fieldSettings.birthday.show || (isCreateClient() && fieldSettings.birthday.required)">
          <date-field
              v-model="data.client.birthday"
              :required="fieldSettings.birthday.required"
              :disabled="fieldSettings.birthday.disabled && !isCreateClient()"
              id="client.birthday"
              name="client_birthday"
              :placeholder="data.filter.person ? 'Дата рождения' : 'Дата регистрации'"
              mb="5"
          />
        </div>
        <div class="col-6" v-if="fieldSettings.sex.show || (isCreateClient() && fieldSettings.sex.required)">
          <select-field
              v-model="data.client.sex"
              :required="fieldSettings.sex.required"
              :disabled="fieldSettings.sex.disabled && !isCreateClient()"
              id="client.sex"
              name="client_sex"
              :options="{1:'Мужской', 2:'Женский'}"
              placeholder="Пол"
              mb="5"
          />
        </div>
      </div>
      <select-field-from-model
          v-model="data.client.economics_sector_id"
          v-if="fieldSettings.economics_sector_id.show || (isCreateClient() && fieldSettings.economics_sector_id.required)"
          :required="fieldSettings.economics_sector_id.required"
          :disabled="fieldSettings.economics_sector_id.disabled && !isCreateClient()"
          id="client.economics_sector_id"
          name="client_economics_sector_id"
          :options="this.economic_sectors"
          placeholder="Сектор экономики"
          mb="5"
      />
      <select-field-from-model
          v-model="data.client.activity_kind_id"
          v-if="fieldSettings.activity_kind_id.show || (isCreateClient() && fieldSettings.activity_kind_id.required)"
          :required="fieldSettings.activity_kind_id.required"
          :disabled="fieldSettings.activity_kind_id.disabled && !isCreateClient()"
          id="client.activity_kind_name"
          name="activity_kind_name"
          :options="this.activityKinds"
          placeholder="Код ОКЭД"
          mb="5"
      />
      <div class="text-gray-700 fw-bold mb-3 ms-2">Адрес</div>
      <select-field
          v-model="data.location.country_id"
          v-if="(fieldSettings.country_id.show || data.location.country_id === 0)"
          :required="fieldSettings.country_id.required"
          :disabled="fieldSettings.country_id.disabled && !isCreateClient() && data.location.country_id !== 0"
          id="location.country_id"
          name="location.country_id"
          :options="this.countries"
          placeholder="Страна резиденства"
          mb="5"
      />
      <area-field
          v-model="data.location.address"
          v-if="fieldSettings.address.show || (isCreateClient() && fieldSettings.address.required)"
          :required="fieldSettings.address.required"
          :disabled="fieldSettings.address.disabled && !isCreateClient()"
          id="location.address"
          name="location.address"
          :class="'h-125px'"
          :placeholder="this.data.filter.person ? 'Адрес' : 'Юридический адрес'"
          type="text"
          mb="5"
      />
      <div class="text-gray-700 fw-bold mb-3 ms-2" v-if="fieldSettings.type_id.show">Документ</div>
      <div v-if="data.documents && data.documents.length > 1" class="row mb-5">
        <customer-document-card v-for="(document, key) in data.documents"
                                :key="key"
                                :document="document"
                                :module="module"
                                :class="document.number !== data.document?.number ? (document.valid ? '' : data.filter.resident ? 'border-danger' : '') : 'border-success'"
                                @click="selectDocument(document)"
        />
      </div>
      <select-field
          v-model="data.document.type_id"
          v-if="fieldSettings.type_id.show || (isCreateClient() && fieldSettings.type_id.required)"
          :required="fieldSettings.type_id.required"
          :disabled="fieldSettings.type_id.disabled && !isCreateClient()"
          id="document.type"
          name="document_type"
          :options="this.types"
          placeholder="Вид документа"
          mb="5"
      />
      <div class="row">
        <div class="col-6" v-if="fieldSettings.number.show || (isCreateClient() && fieldSettings.number.required)">
          <input-field
              v-model="data.document.number"
              :required="fieldSettings.number.required"
              :disabled="fieldSettings.number.disabled && !isCreateClient()"
              id="document.number"
              name="document_number"
              placeholder="Номер документа"
              type="text"
              mb="5"
          />
        </div>
        <div class="col-6" v-if="fieldSettings.issued.show || (isCreateClient() && fieldSettings.issued.required)">
          <date-field
              v-model="data.document.issued"
              :required="fieldSettings.issued.required"
              :disabled="fieldSettings.issued.disabled && !isCreateClient()"
              id="document.date"
              name="document_date"
              :placeholder="this.data.filter.person ? 'Дата выдачи документа' : 'Дата первичной регистрации'"
              mb="5"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6" v-if="fieldSettings.issuer.show || (isCreateClient() && fieldSettings.issuer.required)">
          <input-field
              v-model="data.document.issuer"
              :required="fieldSettings.issuer.required"
              :disabled="fieldSettings.issuer.disabled && !isCreateClient()"
              id="data.document.issuer"
              name="data.document.issuer"
              placeholder="Кем выдано"
              type="text"
              mb="5"
          />
        </div>
        <div class="col-6" v-if="fieldSettings.until.show || (isCreateClient() && fieldSettings.until.required)">
          <date-field
              v-model="data.document.until"
              :required="fieldSettings.until.required"
              :disabled="fieldSettings.until.disabled && !isCreateClient()"
              id="data.document.until"
              name="data.document.until"
              placeholder="Дата завершения"
              mb="5"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <button @click="closeClientData" type="button" class="btn btn-sm btn-warning w-100">Отменить</button>
        </div>
        <div class="col-6">
          <button @click="setClient" type="button" :disabled="!valid || !validEmail || errorMessage.length > 0" class="btn btn-sm btn-primary w-100" v-html="Object.keys(this.dataClient).length !== 0 ? 'Обновить' : 'Создать'"></button>
        </div>
      </div>
    </div>
  </div>
  <loader-full v-else style="height: 400px"/>
</template>

<script>
// Fields
import SelectFieldFromModel from '@/components/Fields/SelectFieldFromModel'
import InputMaskField       from '@/components/Fields/InputMaskField'
import CheckboxField        from '@/components/Fields/CheckboxField'
import SelectField          from '@/components/Fields/SelectField'
import InputField           from '@/components/Fields/InputField'
import DateField            from '@/components/Fields/DateField'
// Modules
import LoaderFull from '@/components/Main/LoaderFull'
import AreaField  from '@/components/Fields/AreaField'
import axios      from 'axios';
import dBrain     from '@/helpers/dBrain'
import CustomerDocumentCard from "@/components/Form/Customer/CustomerDocumentCard.vue";

export default {
  name: 'CustomerData',
  props: {
    searchData: null,
    dataClient: null,
    isClear: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    module: {
      typ: Function,
      required: true
    },
    activityKinds: {
      type: Object,
      required: true
    }
  },
  components: {CustomerDocumentCard, AreaField, LoaderFull, SelectFieldFromModel, CheckboxField, SelectField, DateField, InputField, InputMaskField },
  emits: ['updateClientData', 'closeClientData'],
  data () {
    return {
      data: {
        filter: {
          resident: true,
          person  : true,
          verify  : true,
        },
        client: {
          economics_sector_id:  10,
          activity_kind_id:     250,
          patronymic:           '',
          birthday:             '',
          surname:              '',
          email:                '',
          phone:                '',
          name:                 '',
          iin:                  '',
          sex:                  1,
          id:                   0,
        },
        document: {
          type_id:   1,
          issued:    '',
          number:    '',
          issuer:    '',
          until:     '',
        },
        location: {
          country_id: 1,
          address:    null
        }
      },
      activity_kind_name: '',
      isFilterCountries:  false,
      economic_sectors:   null,
      fieldSettings:      null,
      checkClient:        false,
      validEmail:         false,
      filterStep:         0,
      countries:          null,
      oldFilter:          null,
      typeName:           '',
      loaded:             false,
      types:              null,
      valid:              false,
      errorMessage:       ''
    }
  },
  mounted() {
    this.getEconomicsSector()
    this.getCountries()
    if (this.types && this.data.document) this.typeName = this.types[this.data.document.type_id]
    this.valid = this.isValidObject(this.fieldSettings, this.flattenToValues(this.data))
  },
  methods: {
    selectDocument(document) {
      if (!document.valid && this.data.filter.resident) {
        this.$notifyError({message: 'Документ не верифицирован'})
        return;
      }
      this.data['document'] = document
    },
    closeClientData() {
      this.$emit('closeClientData', 1)
    },
    updateClientData(data) {
      this.$emit('updateClientData', data)
    },
    getEconomicsSector() {
      axios.get('/api/dictionaries/economic-sectors')
          .then(res => {
            this.economic_sectors = res.data
          })
    },
    getCountries() {
      axios.get('/api/dictionaries/countries')
          .then(res => {
            if (!this.isFilterCountries) this.countries = res.data
            else  {
              let countriesToDelete = [
                'Российская Федерация',
                'АРМЕНИЯ ',
                'АЗЕРБАЙДЖАН ',
                'БАНГЛАДЕШ ',
                'БЕЛАРУСЬ ',
                'ИНДИЯ ',
                'КЫРГЫЗСТАН ',
                'Республика Молдова',
                'ТАДЖИКИСТАН ',
                'УКРАИНА ',
                'УЗБЕКИСТАН '
              ]
              this.countries = Object.fromEntries(
                  Object.entries(res.data).filter(([key, value]) => !countriesToDelete.includes(value)))
            }
          })
    },
    setClient: function () {
      this.loaded = true
      let data = structuredClone([this.data])
      if (this.filterStep === 2 || this.filterStep === 3) {
        if (data[0].document) data[0].document.type_id = null
        data[0].client.sex = 0
      }
      axios.post('/api/client/set', data)
          .then(res => {
            let text;
            if (res.data && res.data.hasOwnProperty('result')) {
              if (res.data.result) {
                this.$notifySuccess({message: 'Данные успешно обновлены', title: 'Обновлено'})
                let data = structuredClone(res.data.data)
                if (data.client.hasOwnProperty('phone') && data.client.phone)
                  data.client.phone = data.client.phone.replace(/\D/g, '')
                if (data.document && data.document.hasOwnProperty('until') && this.data.document) {
                  data.document.until = this.data.document.until
                }
                if (data.client.hasOwnProperty('birthday') && !data.client.birthday) data.client.birthday = this.data.client.birthday
                if (data.documents && this.data.documents) {
                  for (let i = 0; i < data.documents.length; i++) {
                    if (data.documents[i].hasOwnProperty('until')) {
                      const localDoc = this.data.documents.find(doc => doc.number === data.documents[i].number)
                      if (localDoc) data.documents[i].until = localDoc.until
                    }
                  }
                }
                this.updateClientData(data)
              } else {
                if (this.data.filter.resident && 'filter' in this.dataClient) this.data.filter = structuredClone(this.dataClient.filter)
                this.$notifyError(res.data, {title: 'Обновлено'})
              }
            } else {
              if (this.data.filter.resident && 'filter' in this.dataClient) this.data.filter = structuredClone(this.dataClient.filter)
              if (res.data.errors) {
                this.$notifyError(res.data)
              }
            }
          })
          .catch(err => {
            if (this.data.filter.resident && 'filter' in this.dataClient) this.data.filter = structuredClone(this.dataClient.filter)
            this.$notifyError(err)
          })
          .finally(() => {
            this.loaded = false
          })
    },
    checkExperience() {
      switch (true) {
        case (this.driver.age < 25 && this.driver.experience === false): this.driver.age_experience_id = 1; break //младше 25 лет стаж меньше 2
        case (this.driver.age < 25 && this.driver.experience === true):  this.driver.age_experience_id = 2; break //младше 25 лет стаж больше 2
        case (this.driver.age >= 25 && this.driver.experience === false): this.driver.age_experience_id = 3; break //больше 25 лет стаж меньше 2
        case (this.driver.age >= 25 && this.driver.experience === true):  this.driver.age_experience_id = 4; break //больше 25 лет стаж больше 2
      }
    },
    flattenToValues(obj) {
      return this.module.Client.flattenToValues(obj)
    },
    isValidObject(rules, data) {
      if (typeof rules !== 'object' || rules === null || typeof data !== 'object' || data === null) {
        return false;
      }

      return Object.entries(rules).every(([field, properties]) => {
        if (!properties.required) return true
        const value = data[field]
        return value !== null && value !== undefined && value !== ''
      });
    },
    isCreateClient() {
      return !(this.dataClient.filter) && (!this.searchData.hasOwnProperty('result'))
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue.location.country_id === 0 && newValue.filter.resident) newValue.location.country_id = 1
        this.filterStep = this.module.Client.filterStep(newValue.filter)
        if (!this.fieldSettings && ((newValue.document?.number && newValue.filter.person) || (!newValue.filter.person))) {
          this.fieldSettings = this.module.Client.recalculateDisabledFields(this.module.Client.fieldsSettings(this.filterStep), newValue)
        }
        this.valid = this.isValidObject(this.fieldSettings, this.flattenToValues(newValue))
        if (!newValue.filter.resident) {
          if (!this.module.Validator.validateNameSurname(newValue.client.name).result || !this.module.Validator.validateNameSurname(newValue.client.surname).result) {
            this.errorMessage = !this.module.Validator.validateNameSurname(newValue.client.name).result
                ? this.module.Validator.validateNameSurname(newValue.client.name).message
                : this.module.Validator.validateNameSurname(newValue.client.surname).message
          }
        }
      }
    },
    'data.client.iin': {
      immediate: true,
      handler(newValue) {
        if (newValue) this.data.client.iin = newValue.toString().replace(/\D/g, '');
      }
    },
    'data.document.type_id' : {
      deep: true,
      handler(newValue) {
        this.typeName = this.types[newValue]
      }
    },
    'data.filter': {
      deep: true,
      handler (newValue) {
        this.filterStep = this.module.Client.filterStep(newValue)
      }
    },
    'data.client.email': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            newValue = newValue.replace(/[^a-zA-Z0-9@._+-]/g, '');
            const parts = newValue.split('@');
            if (parts.length > 2) {
              newValue = parts.shift() + '@' + parts.join('');
            }
            newValue = newValue.replace(/@[^a-zA-Z0-9.-].*/, '@');
            this.data.client.email = newValue;

            const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            this.validEmail = !newValue || emailRegex.test(newValue);
          })
        } else {
          this.validEmail = true;
        }
      }
    },
    filterStep: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.types = this.module.Client.documentType(newValue)
      }
    },
    dataClient: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          if (newValue.client) {
            Object.entries(newValue.client).forEach(([key, value]) => {
              if (this.data.client.hasOwnProperty(key)) this.data.client[key] = structuredClone(value)
            });
            if (!this.data.client.name) this.data.client.name = newValue.client.title
          }
          if (newValue.document) {
            Object.entries(newValue.document).forEach(([key, value]) => {
              if (this.data.document.hasOwnProperty(key)) this.data.document[key] = structuredClone(value)
            });
          }
          if (newValue.location) {
            Object.entries(newValue.location).forEach(([key, value]) => {
              if (this.data.location.hasOwnProperty(key)) this.data.location[key] = structuredClone(value)
            });
          }
          if (newValue.filter) this.data.filter = structuredClone(newValue.filter)
          if (newValue.documents) this.data.documents = structuredClone(newValue.documents)
        }
      }
    },
    searchData: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue && 'data' in newValue && ('doc_type' in newValue.data || 'document_type' in newValue.data)) {
          this.data = dBrain.clientData(newValue.data)
        } else {
          if (newValue) {
            this.data.filter = newValue.filter
            Object.entries(newValue.client).forEach(([key, value]) => {
              this.data.client[key] = value
            });
            const step = this.module.Client.filterStep(newValue.filter)
            const settings = structuredClone(this.module.Client.fieldsSettings(step))
            if (settings) {
              Object.keys(settings).forEach(key => { settings[key].disabled = false })
            }
            this.fieldSettings = settings
          }
          if (newValue && !newValue.filter.person && !this.isEdit) {
            this.data.client.economics_sector_id = null
            this.data.client.activity_kind_id    = null
          }
          // if (this.isCreateClient() && !newValue.filter.resident) {
          //   this.isFilterCountries = true
          // }
        }
      }
    },
  }
}
</script>

<style scoped>

</style>